import { BaseApiSelector } from "@bornfight/aardvark";
import { ResourceType } from "enums/ResourceType";
import { InstructionJSONAModel } from "interfaces/jsona-models/InstructionJSONAModel";

export class InstructionSelector extends BaseApiSelector<InstructionJSONAModel> {
  constructor() {
    super(ResourceType.Instruction);
  }
}
